export function Spinner({ size = "md", label = "Loading" }: { size?: "sm" | "md" | "lg"; label?: string }) {
  return (
    <span className={`spinner spinner--${size}`} role="status" aria-label={label}>
      <span className="spinner__dot" />
      <span className="spinner__dot" />
      <span className="spinner__dot" />
    </span>
  );
}

/** App-owned loading indicator in a reserved region (no layout jump when content arrives). */
export function LoadingBlock({ label = "Loading", minHeight = 240 }: { label?: string; minHeight?: number }) {
  return (
    <div className="loading-block" style={{ minHeight }}>
      <Spinner size="lg" label={label} />
      <span className="loading-block__label" aria-hidden="true">
        {label}…
      </span>
    </div>
  );
}
